<script setup>
import { computed } from 'vue';

const props = defineProps({
  count: { type: [Number, String], default: 0 },
});

const normalizedCount = computed(() => {
  const count = Number(props.count);
  return Number.isFinite(count) && count > 0 ? count : 0;
});

const title = computed(() => String(normalizedCount.value));
</script>

<template>
  <span
    v-if="normalizedCount > 0"
    data-test-id="sidebar-unread-badge"
    :title="title"
    :aria-label="title"
    class="inline-block size-2.5 rounded-full bg-n-brand ring-2 ring-n-surface-1 flex-shrink-0"
  />
  <span v-else class="hidden" />
</template>
